import React from 'react';

import 'assets/css/index.css';
import ReactDOM from 'react-dom';
import {CssBaseline, StylesProvider, ThemeProvider} from '@material-ui/core';
import {NotiStackProvider} from 'providers';

import App from 'App';
import {theme} from 'assets/theme';
import reportWebVitals from './reportWebVitals';
import {version} from '../package.json';


// eslint-disable-next-line no-console
console.info(
    '%c%s',
    'color: green; background: yellow; font-size: 16px;',
    `Environment: ${process.env.NODE_ENV}`
);
console.info(
    '%c%s',
    'color: green; background: yellow; font-size: 16px;',
    `Version: ${version}`
);
ReactDOM.render(
    // <React.StrictMode>
    <StylesProvider injectFirst>
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <NotiStackProvider>
                <App />
            </NotiStackProvider>
        </ThemeProvider>
    </StylesProvider>,
    // </React.StrictMode>,
    document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
